let PROD_URL;
let MEDIA_URL;
let production = true;
if (production) {
  PROD_URL =
    "https://live-app-slate-accelerator-backend-evgxacbtbnatdff3.eastus-01.azurewebsites.net";
  MEDIA_URL =
    "https://live-app-slate-accelerator-backend-evgxacbtbnatdff3.eastus-01.azurewebsites.net";
} else {
  PROD_URL =
    "https://app-slate-accelerator-dqfqe5h6f8bkeyd3.eastus-01.azurewebsites.net";
  MEDIA_URL =
    "https://app-slate-accelerator-dqfqe5h6f8bkeyd3.eastus-01.azurewebsites.net";
}

const BASE_URL = `${PROD_URL}/api/`;
const ADMIN_BASE_URL = `${PROD_URL}/api/admin/`;

const endpoints = {
  login: "auth/userlogin",
  getusermaster: "auth/getusermaster/",
  signup: "auth/createnewuser",
  deleteaccount: "common/deleteaccount",
  checkaccountstatus: "common/checkaccountstatus",
  activateaccount: "common/activateaccount",
  getuserinvitationdetails: "common/getuserinvitationdetails",
  forgetpassword: "auth/checkuserforforgetpassword",
  verifynewuser: "auth/verifynewusermaster",
  dashboarddata: "recruiter/dashboarddata",
  checkforgetpasswordlink: "auth/checkforgetpasswordlink",
  setchangepassword: "auth/changepasswordforfortgotrequrest",
  verifynewusermasterforedit: "auth/verifynewusermasterforedit",
  updateemailforuser: "auth/updateemailforuser",
  createcontract: "auth/createcontract",
  edituserprofile: "auth/edituserprofile",
  changepassword: "auth/changepassword",
  addupdatecandidateinfo: "recruiter/addupdatecandidateinfo",
  searchcandidates: "client/searchcandidates",
  downloadlimit: "/client/updateresumedownloadlimit",
  getallsearchhistory: "client/getallsearchhistory",
  searchcandidatesbysearchlog: "client/searchcandidatesbysearchlog",
  getallmasterdata: "common/getallmasterdata",
  getallindustrydata: "common/getallindustrydata",
  contractdetails: "common/contractdetails",
  getallcitymaster: "common/getallcitymaster",
  updatecandidateresumestatus: "common/updatecandidatestatus",
  deletecandidateafterconfirmation:
    "recruiter/deletecandidateafterconfirmation",
  initiatesubscriptionpayment: "common/initiatesubscriptionpayment",
  updatesubscriptionplan: "common/updatesubscriptionplan",
  cancelsubscription: "common/cancelsubscription",
  updatepaymentmode: "client/updatepaymentmode",
  updatepaymentinfo: "client/updatepaymentinfo",
  confirmsubscriptionpayment: "common/confirmsubscriptionpayment",
  generateaccountsetuplinkrequest: "common/generateaccountsetuplinkrequest",
  updatestatusofcandidateinviewdetail:
    "client/updatestatusofcandidateinviewdetail",
  checkstripeconnectaccountstatus: "common/checkstripeconnectaccountstatus",
  getrejectedcandidatelist: "client/getrejectedcandidatelist",
  getshortlistedcandidates: "client/getshortlistedcandidates",
  getlistofreportsforclient: "client/getlistofreportsforclient",
  getlistofreportsforrecruiter: "recruiter/getlistofreportsforrecruiter",
  getlistofrecruiterearning: "recruiter/getlistofrecruiterearning",
  getuniversities: `common/getuniversities`,
  getuniversitydegrees: `common/getuniversitydegrees`,
  deleterecruiterstripeconnect: "recruiter/deleterecruiterstripeconnect",
  updatestatusofcandidateinrecruiter:
    "/recruiter/updatestatusofcandidateinrecruiter",
  // Admin Start
  adminSignup: "createnewadmin",
  userinvitation: "admin/userinvitation",
  recruiterDetails: "getrecruiterandclientlistbytype",
  addUpdateSubscription: "insertupdatesubscription",
  getSubscriptionPlans: "getallsubscriptionmaster",
  deleteSubscriptionPlans: "deletesubscriptionmaster",
  adminList: "getadminlist",
  listofsearchlog: "getlistofsearchlog",
  addUpdateSubscription: "insertupdatesubscription",
  getSubscriptionPlans: "getallsubscriptionmaster",
  deleteSubscriptionPlans: "deletesubscriptionmaster",
  deleteAdmin: "deleteadminmaster",
  addupdateservicedetails: "addupdateservicedetails",
  getallservicedetails: "getallservicedetails",
  getallcandidates: "getallcandidates",
  deleterecruiterandclient: "deleterecruiterandclient",
  deleteservicedetail: "deleteservicedetail",
  getlistofclientlog: "getlistofclientlog",
  dashboard: "dashboarddata",
  gethiredcandidates: "gethiredcandidates",
  generateinvoice: "generateinvoice",
  getlistofreportsforadmin: "getlistofreportsforadmin",
  processofflinepayment: "processofflinepayment",
  updatestatusofcandidateinrecruiter:
    "recruiter/updatestatusofcandidateinrecruiter",
  getdeleteduserslist: "getdeleteduserslist",
  insertorupdateparsingdata: "insertorupdateparsingdata",
  getallparsingdata: "getallparsingdata",
  payout: "payout",
  processforrecruiterpayment: "processforrecruiterpayment",
  getpayoutlist: "getpayoutlist",
  getofferextendedlist: "getofferextendedlist",
  getofferdeclinedreport: "getofferdeclinedreport",
  getofferdeclinedlist: "getofferdeclinedlist",
  getrejectedcandidatereport: "getrejectedcandidatereport",
  processforreturnpayment: "processforreturnpayment",
  getlistofcontactus: "getlistofcontactus ",

  // Admin End
};
export { BASE_URL, endpoints, ADMIN_BASE_URL, MEDIA_URL };
